'use strict';

var MappedRulesService = function MappedRulesService(restangular, $q) {
  var rulesSearchAPI = restangular.all('rules');
  var getAppliedRules = function getAppliedRules(appliedRules) {
    appliedRules = appliedRules || [];
    appliedRules = appliedRules.map(function (rule) {
      return rule.replace(/R_|U_/g, '');
    });
    return getRulesByIDs(appliedRules);
  };
  var getRulesByIDs = function getRulesByIDs(technicalId) {
    if (Array.isArray(technicalId) && technicalId.length > 0) {
      return rulesSearchAPI.get('?filter=technicalId=in=(' + technicalId.toString() + ');isUserOverride==false');
    } else {
      return $q.reject('No rules applied');
    }
  };
  return {
    getAppliedRules: getAppliedRules
  };
};
MappedRulesService.$inject = ['Restangular', '$q'];
module.exports = MappedRulesService;